module.exports = __webpack_public_path__ + "img/status_preparing_ingredients_2.66d84d97.png";